<template>
	<EduCardWithLink :camp="camp" :type="type" @clickEduCard="handleClickEduCard">
		<template v-slot:chip>
			<EduCardChipGroup :camp="camp" :is-free-schedule="isFreeSchedule" />
		</template>
		<template v-slot:title>
			<EduCardTitle :camp-group="groupObject" :partner="partner" />
		</template>
	</EduCardWithLink>
</template>

<script>
import EduCardWithLink from './EduCardWithLink.vue';
import EduCardChipGroup from './EduCardChipGroup.vue';
import EduCardTitle from './EduCardTitle.vue';
export default {
	name: 'EduCardInGrid',
	props: {
		camp: {
			type: Object,
			default: () => {},
			required: true,
		},
		partner: {
			type: Object,
			default: () => {},
		},
		isFreeSchedule: {
			type: Boolean,
			default: false,
		},
		type: String,
	},
	computed: {
		groupObject() {
			return this.camp.edu_camp_group || this.camp;
		},
	},
	methods: {
		handleClickEduCard(camp) {
			this.$emit('clickEduCard', camp);
		},
	},
	components: {
		EduCardWithLink,
		EduCardChipGroup,
		EduCardTitle,
	},
};
</script>

<style scoped></style>
